"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _isText = require("../../helpers/isText");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Text = require("../Text");

var _Check = require("./Check");

var _tokens = require("./tokens");

var _excluded = ["selected", "children", "error", "disabled", "hover", "focus", "onSelect", "onClick"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** A checkbox */
var Checkbox = function Checkbox(_ref) {
  var _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      children = _ref.children,
      error = _ref.error,
      disabled = _ref.disabled,
      hover = _ref.hover,
      focus = _ref.focus,
      onSelect = _ref.onSelect,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  var isSelectable = !disabled && onSelect !== undefined;

  var handleClick = function handleClick(event) {
    if (isSelectable && onSelect) {
      onSelect(!selected);
    }

    if (onClick !== undefined) {
      onClick(event);
    }
  };

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === " " && isSelectable && onSelect) {
      event.preventDefault();
      onSelect(!selected);
    }
  };

  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    display: "flex",
    alignItems: "center",
    onClick: handleClick,
    tabIndex: disabled ? -1 : 0,
    onKeyPress: handleKeyPress,
    role: "checkbox",
    "aria-checked": selected,
    selected: selected,
    hover: hover,
    focus: focus,
    disabled: disabled,
    error: error
  }, rest), /*#__PURE__*/_react.default.createElement(_Check.Check, {
    selected: selected,
    error: error,
    disabled: disabled,
    focus: focus,
    hover: hover
  }), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    alignItems: "center",
    flex: 1
  }, (0, _isText.isText)(children) ? /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "sm-display",
    lineHeight: 1
  }, children) : children));
};

exports.Checkbox = Checkbox;
Checkbox.displayName = "Checkbox";
var Container = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Checkbox__Container",
  componentId: "j97vg8-0"
})(["user-select:none;", ""], function (props) {
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", " &:hover{", "}&:focus{", " > div:first-of-type{", "}}&:disabled{", "}"], props.selected ? _tokens.CHECKBOX_STATES.selected : _tokens.CHECKBOX_STATES.default, props.focus && _tokens.CHECKBOX_STATES.focus, props.hover && _tokens.CHECKBOX_STATES.hover, props.disabled && _tokens.CHECKBOX_STATES.disabled, props.error && _tokens.CHECKBOX_STATES.error, !props.error && (0, _styledComponents.css)(["", " > div:first-of-type{", "}"], _tokens.CHECKBOX_STATES.hover, props.selected ? _tokens.CHECK_STATES.hover.selected : _tokens.CHECK_STATES.hover.resting), _tokens.CHECKBOX_STATES.focus, props.selected ? _tokens.CHECK_STATES.focus.selected : _tokens.CHECK_STATES.focus.resting, _tokens.CHECKBOX_STATES.disabled);
});
//# sourceMappingURL=Checkbox.js.map